export function circleOverlap(ax: number, ay: number, ar: number, bx: number, by: number, br: number): boolean {
  const dx = ax - bx;
  const dy = ay - by;
  const r = ar + br;
  return dx * dx + dy * dy <= r * r;
}

export function sweptCircleVsCircle(
  fromX: number,
  fromY: number,
  toX: number,
  toY: number,
  radius: number,
  targetX: number,
  targetY: number,
  targetRadius: number,
): boolean {
  const vx = toX - fromX;
  const vy = toY - fromY;
  const wx = targetX - fromX;
  const wy = targetY - fromY;
  const vv = vx * vx + vy * vy;
  let t = vv > 0.000001 ? (wx * vx + wy * vy) / vv : 0;
  if (t < 0) t = 0;
  else if (t > 1) t = 1;
  const px = fromX + vx * t;
  const py = fromY + vy * t;
  const dx = targetX - px;
  const dy = targetY - py;
  const rr = radius + targetRadius;
  return dx * dx + dy * dy <= rr * rr;
}

export function segmentVsCircle(
  ax: number,
  ay: number,
  bx: number,
  by: number,
  cx: number,
  cy: number,
  radius: number,
): boolean {
  const vx = bx - ax;
  const vy = by - ay;
  const wx = cx - ax;
  const wy = cy - ay;
  const vv = vx * vx + vy * vy;
  let t = vv > 0.000001 ? (wx * vx + wy * vy) / vv : 0;
  if (t < 0) t = 0;
  else if (t > 1) t = 1;
  const px = ax + vx * t;
  const py = ay + vy * t;
  const dx = cx - px;
  const dy = cy - py;
  return dx * dx + dy * dy <= radius * radius;
}
